const WidgetTypes = {
    setup: () => {
        require('./channels-temporal/index')
        require('./channels-value/index')
    }
}

export default WidgetTypes
